<template>
  <div class="contact-conversations" :class="{ 'contact-conversations--has-one': conversations.length === 1 }">
    <n-loading-spinner v-if="loading" />
    <div class="contact-conversations__list" v-if="!loading && conversations.length > 0">
      <div
        class="contact-conversations__list-item-container"
        v-for="(conversation, index) of conversations"
        :key="conversation.id"
      >
        <div class="contact-conversations__list-item">
          <ContactConversation
            :conversation="conversation"
            :workspaceId="workspaceId"
            :expanded="index === 0"
            :class="{ 'contact-conversation--fill-height': conversations.length === 1 }"
          />
        </div>
      </div>
    </div>
    <div class="contact-conversations__empty" v-if="!loading && conversations.length === 0">No conversations found</div>
  </div>
</template>
<script lang="ts" setup>
import { Conversation } from '../models/conversation';
import ContactConversation from './ContactConversation.vue';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import { PropType } from 'vue';

defineProps({
  conversations: {
    type: Array as PropType<Conversation[]>,
    default: [],
  },
  workspaceId: {
    type: String,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="scss" scoped>
.contact-conversations {
  display: flex;
  flex-direction: column;
  overflow: auto;
  &--has-one {
    max-height: 100%;
  }
  &__list {
    position: relative;
    padding-left: 1rem;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: auto;
  }
  &__timeline {
    width: 2px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 1.5rem;
    background: #d0d1d5;
  }
  &__list-item-container {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
    &::before {
      content: '';
      position: absolute;
      width: 2px;
      height: calc(100% + 2.5rem);
      background: #d0d1d5;
    }
    &:last-of-type {
      &::before {
        display: none;
      }
      .contact-conversations__list-item {
        padding-bottom: 1.5rem;
      }
    }
    &:first-of-type {
      .contact-conversations__list-item {
        padding-top: 1.5rem;
        &::before,
        &::after {
          top: 3.25rem;
        }
      }
    }
  }
  &__list-item {
    position: relative;
    padding: 0.75rem 1.5rem 0.75rem 1rem;
    display: flex;
    flex-direction: column;
    min-height: 0;
    &::before {
      content: '';
      position: absolute;
      top: 2.5rem;
      left: 1px;
      height: 1rem;
      width: 1rem;
      background: #f2f2f2;
      border-radius: 2px;
      transform: translate(-50%, -50%);
    }
    &::after {
      content: '';
      position: absolute;
      top: 2.5rem;
      left: 1px;
      height: 12px;
      width: 12px;
      background: #d3d3d3;
      border-radius: 100%;
      transform: translate(-50%, -50%);
    }
  }
  &__empty {
    padding: 2rem 1rem;
  }

  :deep(.contact-conversation--fill-height) {
    .contact-conversation__message-container {
      max-height: 100%;
    }
  }
}
</style>
